import React from "react";
import PropTypes from "prop-types";
import {useHistory} from "react-router-dom";
import discuter from "../../assets/icons/discuter.svg";
import useWindowDimensions from "../../hook/useWindowDimension";
import telIcone from "../../assets/icons/tel.svg";

const Card = ({
				  listDocuments,
				  listMessages,
				  listCasesWithContacts,
				  handleOpenNavItem,
				  navItem
			  }) => {
	const history = useHistory();
	const {width} = useWindowDimensions();
	return (
		<>
			{	// Liste des cas avec le nom du Care Manager ainsi que le nom de la personne
				listCasesWithContacts.map((cas) => {
// Nombre de document pour chaque cas
					const numberOfDoc = listDocuments.filter((i) => i.idCase == cas.id).length;
// Nombre de nouveau message pour chaque cas
					const numberOfMessages = listMessages.filter((i) => i.idCase == cas.id && i.status == 0).length;
// const contact = listContacts.filter((i) => i.idCase == cas.id);
					return (
// Au clique sur la Card on redirige vers le cas en fonction de son id et donc vers le composant <ChatCase/>
						<li key={cas.id} onClick={() => {
							handleOpenNavItem("careManager");
							history.push(`/case/${cas.id}`);
						}}
							id={"contactManagerBlock"}>
							<div className={"chatCaseCMCard"}>
								<img className="photo-care-manager"
									 src={`https://adherents.prevandcare.com/uploads/pictures/${cas.idCareManager}.jpg`}
									 alt="photo care manager"/>
								<div className={"manager-card"}>
									<div className={"manager-card-infos"}>
										<h1>{cas.firstname} {cas.name}</h1>
										<h2>Votre Care Manager dédié pour {cas.prenom} {cas.nom}</h2>
										{(((navItem !== "accueil") && width < 599)
												|| (width > 599))
											&&
											<p>
												<img src={telIcone} className={"icone"}/>
												{cas.tel}
											</p>
										}
									</div>
								</div>
							</div>
							<div className="notifications">
								<div>
									<h3>{numberOfMessages}&nbsp;{numberOfMessages < 2 ? "nouveau" : "nouveaux"}&nbsp;{numberOfMessages < 2 ? "message" : "messages"}</h3>
								</div>
								{(((navItem !== "accueil") && width < 599)
										|| (width > 599))
									&&
									<div><h3>{numberOfDoc}&nbsp;{numberOfDoc < 2 ? "document" : "documents"}</h3></div>
								}
							</div>
							<button className="discuter">
								<img src={discuter} alt="discuter"/> Discuter
							</button>

						</li>
					);
				})
			}
		</>
	);
};

Card.propTypes = {
	listCasesWithManager: PropTypes.array,
	listDocuments: PropTypes.array,
	listMessages: PropTypes.array,
	listContacts: PropTypes.array,
	listCasesWithContacts: PropTypes.array,
	handleOpenNavItem: PropTypes.func,
	navItem: PropTypes.object
};

export default Card;
